import { OrbitControls, useGLTF, useTexture, MeshTransmissionMaterial, Center, Text3D} from '@react-three/drei'
import { useFrame, useThree } from '@react-three/fiber'
import * as THREE from 'three'
import gsap from 'gsap'
import { EffectComposer, Bloom } from '@react-three/postprocessing'
import SnowFlakes from './Snowflake'
import FireWorks from './FireWorks'
import { useLayoutEffect, useMemo, useRef, useState, useEffect } from 'react'
import { texture } from 'three/tsl'

export default function Experience()
{
    const { nodes } = useGLTF('./model/cottage.glb')

    const bakedTexture = useTexture('./model/cottage.jpg')
    bakedTexture.flipY = false
    
    return <>

        <color args={ [ '#000811' ] } attach="background" />

        <OrbitControls 
        makeDefault
        autoRotate={true}
        autoRotateSpeed={0.5}  // slow and gentle (default is 2.0)
        enableDamping={true}
        dampingFactor={0.05}
        // Optional: limit how far it can rotate vertically
        minPolarAngle={Math.PI / 4}
        maxPolarAngle={Math.PI / 2.5}
        />
        <EffectComposer>
            <Center>
                <group>
                    <mesh
                    geometry={ nodes.baked.geometry }
                    position={ nodes.baked.position }
                    rotation={ nodes.baked.rotation }
                    scale={ nodes.baked.scale }
                    castShadow
                    receiveShadow
                    >
                        <meshBasicMaterial map={ bakedTexture } />
                    </mesh>
                    <mesh 
                        geometry={ nodes.ball.geometry }
                        position={ nodes.ball.position}
                        rotation={ nodes.ball.rotation}
                        scale={ nodes.ball.scale}
                        castShadow
                        receiveShadow
                        >
                        <MeshTransmissionMaterial />
                        <SnowFlakes count={100} />
                    </mesh>
                </group>
            </Center>
            <FireWorks position={[3, 0, 0]}/>
            <Bloom intensity={1.0}        // glow strength — try 1.0 to 2.5
                luminanceThreshold={0.1} // what counts as "bright" (lower = more glow)
                luminanceSmoothing={0.9} // softness
                radius={0.8}/>
        </EffectComposer>
       
    </>
}